import type { User } from "../types";

export const DEFAULT_REPLAY_SAMPLE_RATE = 100;
export const DEFAULT_SAMPLE_RATE = 100;

export const DEFAULT_USER: User = {};
